import React from 'react';
import { connect } from 'react-redux';
import actionProps from 'actions';

import { Link } from 'react-router';
import { Button, OverlayTrigger, Tooltip, Alert } from 'react-bootstrap';
import { FaIcon, Toggle } from 'components/utilities';

const promptIOS = require('images/etc/mobile-app-ios.png');
const promptAndroid = require('images/etc/mobile-app-android.png');

class LoginIndex extends React.Component {

  constructor() {
    super();

    this.state = {
      creds: {
        identifier: '',
        password: '',
      },
    };
  }

  updateCreds = e => {
    const creds = Object.assign({}, this.state.creds);
    creds[e.target.name] = e.target.value;
    this.setState({ creds });
  }

  performLogin = e => {
    e.preventDefault();

    const { returnTo } = this.props;
    const { login } = this.props.actions;

    login({
      credentials: this.state.creds,
      returnTo,
    });
  }

  renderHeader = () => {
    const mobile = window.innerWidth <= 820;
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const props = {
      width: 327,
      height: 129,
      role: 'presentation',
      style: {
        marginBottom: '2em',
        marginTop: '-1.5em',
      },
    };

    /* eslint-disable jsx-a11y/img-has-alt */
    if (mobile && /android/i.test(userAgent)) {
      return (
        <a href="https://play.google.com/store/apps/details?id=com.app.greekcapitalmanagement&hl=en_US">
          <img src={promptAndroid} {...props} />
        </a>
      );
    }

    if (mobile && /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return (
        <a href="https://apps.apple.com/app/apple-store/id1021134061">
          <img src={promptIOS} {...props} />
        </a>
      );
    }
    /* eslint-enable jsx-a11y/img-has-alt */

    return <h3>Welcome back!</h3>;
  }

  render() {
    const { authenticating, errorStatus } = this.props;

    const quickPayExplanation = <Tooltip id="tooltip"><strong>Pay your bill without logging in.</strong></Tooltip>;
    // const magicLinkExplanation = <Tooltip id="tooltip"><strong>Respond to a text message to be logged in.</strong></Tooltip>;

    return (
      <div className="account-wrapper">

        {this.renderHeader()}

        <Toggle show={this.state.magicLinkSent}>

          <Alert bsStyle="success" className="text-left">
            <p className="fw-semibold">A text message was sent to your cell *{this.state.lastFourOfPhone}.</p>
            <p>Respond "y" to that text and this page will automatically refresh.</p>
          </Alert>

        </Toggle>

        <Toggle show={!this.state.magicLinkSent}>

          <Button bsStyle="success" componentClass="a" href="/quick-pay" block>
            <FaIcon bolt />
            &nbsp; Quick pay
            <OverlayTrigger placement="left" overlay={quickPayExplanation}>
              <div className="pull-right">
                <FaIcon question-circle />
              </div>
            </OverlayTrigger>
          </Button>

        </Toggle>

        <form
          className="form account-form account-body"
          action="/sessions"
          onSubmit={this.performLogin}
        >

          <div className="form-group">
            <input type="text" name="identifier"
              defaultValue={this.state.creds.identifier}
              onChange={this.updateCreds.bind(this)}
              className="form-control" placeholder="Email"
              tabIndex="1" autoFocus />
          </div>

          {/*
          <div className="form-group">
            <Button bsStyle="secondary" block disabled={this.state.lastFourOfPhone === null} onClick={this.sendMagicLink.bind(this)}>
              <FaIcon mobile />
              &nbsp; Send a magic link {this.state.lastFourOfPhone ? `to *${this.state.lastFourOfPhone}` : null}

              <OverlayTrigger placement="left" overlay={magicLinkExplanation}>
                <div className="pull-right">
                  <FaIcon question-circle />
                </div>
              </OverlayTrigger>
            </Button>
          </div>
          */}

          <div className="form-group forgot-password">
            <Link to={`/forgot-password?email=${this.state.creds.identifier}`}>forgot?</Link>
            <input type="password" name="password"
              defaultValue={this.state.creds.password}
              onChange={this.updateCreds.bind(this)}
              className="form-control" placeholder="Password"
              tabIndex="2" />
          </div>

          {errorStatus && errorStatus >= 500 ? (
            <Alert bsStyle="warning" className="text-left">
              <p className="fw-semibold">
                <FaIcon exclamation-triangle />
                &nbsp; It looks like there was a hiccup, try logging in again.
              </p>
            </Alert>
          ) : null}

          {errorStatus && errorStatus < 500 ? (
            <Alert bsStyle="danger" className="text-left">
              <p className="fw-semibold">
                <FaIcon exclamation-triangle />
                &nbsp; Incorrect credentials
              </p>
              <Link to="/forgot-password" className="no-style">Did you forget your password? click here.</Link>
            </Alert>
          ) : null}

          <div className="form-group">
            <Button type="submit" bsStyle="primary" block tabIndex="4"
              disabled={authenticating}>Sign in</Button>
          </div>

        </form>

      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => ({
  returnTo: ownProps.location.query.return,
  errorStatus: state.get('auth') ? state.get('auth').status : null,
  authenticating: !_.isNull(state.get('auth')) && state.get('auth').authenticating === true,
});

export default connect(mapStateToProps, actionProps)(LoginIndex);
